var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.5C2.17157 4.5 1.5 5.17157 1.5 6V18C1.5 18.8284 2.17157 19.5 3 19.5H21C21.8284 19.5 22.5 18.8284 22.5 18V6C22.5 5.17157 21.8284 4.5 21 4.5H3ZM0.5 6C0.5 4.61929 1.61929 3.5 3 3.5H21C22.3807 3.5 23.5 4.61929 23.5 6V18C23.5 19.3807 22.3807 20.5 21 20.5H3C1.61929 20.5 0.5 19.3807 0.5 18V6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 10C0.5 9.72386 0.723858 9.5 1 9.5H23C23.2761 9.5 23.5 9.72386 23.5 10C23.5 10.2761 23.2761 10.5 23 10.5H1C0.723858 10.5 0.5 10.2761 0.5 10Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/credit-card.02628f436c12b26c256ce73d3da78bf7.svg";